import { message, notification } from "antd";
import { GET_LOCAL_STORAGE, LOCAL_STORAGE_KEY } from "../helpers/localStorage";
import { LOGGER } from "../helpers/logger";
import { API_CONSTANTS } from "./Constants";
import axiosHttp from "./axiosInterceptor";
import { showError, showSuccess } from "../helpers/alerts";
import { useProjectInfoStore } from "../zustand/store/projectInfoStore";
export const currentRole = GET_LOCAL_STORAGE(
  "a44ed839-c22a-49e6-ab36-a44574323f0c"
);
export const userEmail = GET_LOCAL_STORAGE("email");
export const userRegion = GET_LOCAL_STORAGE("userRegion") || "Singapore";
export const userNameLocal =
  GET_LOCAL_STORAGE("userName") || userEmail?.split("@")[0];
export const removeDuplicateArrayValue = (data) => [...new Set(data)];
// ---------- helper function
export function getProjectId() {
  const pathname = window.location.pathname; // Get the current pathname
  const segments = pathname.split("/"); // Split the pathname into segments
  // console.log("---->Query Params", segments);
  const id =
    segments[2] || GET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.currentFLProjectId); // Get the ID from the URL or local storage
  // console.log("---->Query Params", id);
  return id;
}
const getClientAssignFormattedMsg = (params, method) => {
  const messages =
    `Client ${method} Successfully ` +
    params.map(
      (item) => ` Client Name: ${item.clientName}, Region: ${item.region}`
    );
  return messages;
};

const activityLog = {
  PROJECT_CREATE: (params) => ({
    createdBy: userNameLocal,
    role: currentRole,
    region: userRegion,
    message: "Project info created",
    email: userEmail,
    ...params,
  }),
  CLIENT_ASSIGN: (params) => ({
    createdBy: userNameLocal,
    role: currentRole,
    region: userRegion,
    message: getClientAssignFormattedMsg(params, "Assigned"),
    email: userEmail,
    projectId: getProjectId(), // Call getProjectId when this log is used
  }),
  CLIENT_UPDATE_ASSIGN: (params) => ({
    createdBy: userNameLocal,
    message: getClientAssignFormattedMsg(params, "Updated"),
    email: userEmail,
    role: currentRole,
    region: userRegion,
    projectId: getProjectId(), // Call getProjectId when this log is used
  }),
  PROJECT_INFO_UPDATED: (params) => ({
    createdBy: userNameLocal,
    message: "Project Info Updated",
    email: userEmail,
    role: currentRole,
    region: userRegion,
    projectId: getProjectId(), // Call getProjectId when this log is used
  }),
  CREATE_GITHUB: (params) => ({
    createdBy: userNameLocal,
    message: "Github Connection Configured",
    email: userEmail,
    role: currentRole,
    region: userRegion,
    projectId: getProjectId(), // Call getProjectId when this log is used
  }),
  UPDATE_GITHUB: (params) => ({
    createdBy: userNameLocal,
    message: "Github Connection Config Updated",
    email: userEmail,
    role: currentRole,
    region: userRegion,
    projectId: getProjectId(), // Call getProjectId when this log is used
  }),
  INFRA_CREATE: (params) => ({
    createdBy: userNameLocal,
    message: `Infra Type: ${params?.infraType}, ${
      params?.clientName ? `Client Name: ${params?.clientName}, ` : ""
    }Instance Name: ${params?.name}, Created Successfully`,
    email: userEmail,
    role: currentRole,
    region: userRegion,
    projectId: getProjectId(), // Call getProjectId when this log is used
  }),
  CLIENT_REGION_CREATE: (params) => ({
    createdBy: userNameLocal,
    message: `New Client (${params?.clientName}) Created at ${params?.region}`,
    email: userEmail,
    role: currentRole,
    region: userRegion,
    projectId: getProjectId(), // Call getProjectId when this log is used
  }),
  CLIENT_REGION_UPDATE: (params) => ({
    createdBy: userNameLocal,
    message: `Client Updated`,
    email: userEmail,
    role: currentRole,
    region: userRegion,
    projectId: getProjectId(), // Call getProjectId when this log is used
  }),
  PROJECT_APPROVED: () => ({
    createdBy: userNameLocal,
    role: currentRole,
    region: userRegion,
    message: "Project Approved",
    email: userEmail,
    projectId: getProjectId(),
  }),
  PROJECT_TRAIN_COMPLETED: () => ({
    createdBy: userNameLocal,
    role: currentRole,
    region: userRegion,
    message: "Training Completed",
    email: userEmail,
    projectId: getProjectId(),
  }),
};

// ---------
export const createTodoApiCall = async (inputData) => {
  try {
    const response = await axiosHttp.post(API_CONSTANTS.USER_CREATE, inputData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const fetchUsers = async () => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.USER_LIST}?event_type=list_user&user_role=${currentRole}`
    );
    const result = response.data;
    return result.data.Users.map((user, index) => ({
      key: index,
      name: user.userName,
      email: user.email,
      projects: [], // Add the projects if available
      password: "",
      userCategory: user?.userCategory || "",
      siteName: user?.siteName || "",
      status: user?.userStatus,
      userRegion: user.userRegion,
      role: user.roles,
    }));
  } catch (error) {
    LOGGER(error);
  }
};
export const deleteUser = async (data) => {
  try {
    const response = await axiosHttp.delete(API_CONSTANTS.DELETE_USER, {
      params: {
        event_type: "delete_user",
        email: data.email,
        user_role: currentRole,
      },
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};

export const updateUser = async (userData) => {
  try {
    const response = await axiosHttp.put(
      `${API_CONSTANTS.BASE_URL}/update-user?event_type=update_user&email=${
        userData.email
      }&user_role=${currentRole}&roles=${String(userData.role)}&username=${
        userData.name
      }&siteName=${userData.siteName}`,
      null
    );
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const fetchUserProfile = async () => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.USER_LIST}?event_type=user_profile&email=${userEmail}`
    );
    return response.data[0];
  } catch (error) {
    LOGGER(error);
  }
};

export const createProject = async (userData) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.PROJECT}`, {
      record: { ...userData, email: userEmail },
      action: "insert_record",
      log: activityLog.PROJECT_CREATE({
        projectId: getProjectId(),
        projectTitle: userData.projectTitle,
      }),
      projectNotifyLog: {
        title: `New Project Created(${userData?.projectTitle}) `,
        description: `New project created and assigned you | ${userData?.projectDescription}`,
        notificationType: "email",
        notificationTo: removeDuplicateArrayValue([
          { Project_Admin: userData?.projectOwner },
          { FL_Engineer: userData?.federatedEngineer },
          { ML_Engineer: userData?.mlEngineer },
        ]),
        createdBy: {
          role: currentRole,
          email: userEmail,
        },
      },
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const getRegion = async () => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.INFRA}?event_type=region`
    );
    return response.data.body.sort();
  } catch (error) {
    LOGGER(error);
  }
};
export const getInstanceType = async (region) => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.INFRA}?event_type=instance_type&region=${region}`
    );
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const getVpcList = async (region) => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.INFRA}?event_type=vpc&region=${region}`
    );
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};

export const getInstanceByResourceList = async (
  cpu,
  memory,
  region,
  resourceTypeInput,
  gpuValue,
  infraType
) => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.INFRA}?event_type=instance&gpu=${gpuValue}&cpu=${cpu}&memory=${memory}&region=${region}&instance_type=${resourceTypeInput}&infraType=${infraType}`
    );
    return response?.data?.body;
  } catch (error) {
    LOGGER(error);
  }
};

export const getSubnetList = async (region, selectedVpcId) => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.INFRA}?event_type=subnet&region=${region}&vpc_id=${selectedVpcId}`
    );
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const getUserByRole = async (role) => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.USER_LIST}?event_type=get_user_role_list&role=${role}`
    );
    // console.log("===========>", response.data);
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const getInstanceCost = async (infra) => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.INFRA}?event_type=instance_config&region=${infra.region}&instance_type=${infra.instanceType}`
    );
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const fetchVersions = async (dataPro) => {
  try {
    const response = await axiosHttp.post(
      `${API_CONSTANTS.CLIENT_PROGRESS_Dev_BASE_URL}server-progres`,
      {
        event_type: "list_server_version",
        projectKey: dataPro?.project_key, // Pass project key if applicable
      }
    );
    if (response?.data?.statusCode == 200) {
      return response.data.body;
      // Update versions state with API response
    }
  } catch (error) {
    LOGGER(error);
  }
};

export const infraCreation = async (infraData) => {
  const id = getProjectId();
  if (id) {
    try {
      let event_type = "insert_record";
      let record = {
        projectId: id,
        ...infraData,
        record_id: infraData.isEc2Edit,
      };
      if (infraData.isEc2Edit) {
        event_type = "update_ec2_record";
        record = {
          projectId: id,
          ...infraData,
          record_id: infraData.isEc2Edit, //getting record_id
        };
      }
      delete record.isEc2Edit;
      const response = await axiosHttp.post(`${API_CONSTANTS.INFRA}`, {
        action: event_type,
        record: record,
        ec2NotifyLog: {
          title: "Ec2 configured",
          project_key_value: record?.project_key,
          region: record?.region,
          description: `Infra Type: ${infraData?.infraType}, ${
            infraData?.clientName
              ? `Client Name: ${infraData?.clientName}, `
              : ""
          }Instance Name: ${infraData?.name}, Created Successfully`,
          notificationType: null,
          notificationTo: null,
          createdBy: {
            role: currentRole,
            email: userEmail,
          },
        },
        log: activityLog.INFRA_CREATE(infraData),
      });
      if (response.data.statusCode == 500) {
        showError("Please Complete the Github Configuration");
      }

      return response.data;
    } catch (error) {
      LOGGER(error);
    }
  } else {
    showError("Please complete the project info");
  }
};
export const ec2InstanceCreation = async (infraData) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.JENKINS}`, {
      event_type: "aws_ec2",
      ...infraData,
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const createPatch = async ({ projectKey, version }) => {
  try {
    const response = await axiosHttp.post(
      `${API_CONSTANTS.CLIENT_PROGRESS_Dev_BASE_URL}server-progres`,
      {
        event_type: "create_patch",
        projectKey: projectKey,
        version: version,
        notificationLog: {
          title: "Server Patch Created",
          project_key_value: projectKey,
          description: null,
          version: version,
          notificationType: "email",
          region: userRegion,
          notificationTo: null,
          createdBy: {
            role: currentRole,
            email: userEmail,
          },
        },
      }
    );
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const trainModelWithPatch = async (data) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.MODEL_TRAIN}`, {
      ...data,
      log: activityLog.PROJECT_TRAIN_COMPLETED(data),
      notificationLog: {
        title: "Model Training Started",
        project_key_value: data?.projectKey,
        description: null,
        notificationType: "email",
        region: userRegion,
        notificationTo: null,
        createdBy: {
          role: currentRole,
          email: userEmail,
        },
      },
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const listPatchVersion = async (projectKey, version) => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.CLIENT_PROGRESS_Dev_BASE_URL}server-progres`,
      {
        params: {
          event_type: "list_patch",
          projectKey: projectKey,
          version: version,
        },
      }
    );
    if (response.data.statusCode == 200) {
      if (response.data?.body?.patch_versions?.length > 0) {
        // showSuccess("Patch Founded");
      }
      return response.data.body.patch_versions;
    } else {
      // message.warning("The patch is empty for the selected server version");
    }
  } catch (error) {
    LOGGER(error);
  }
};

export const fetchTrainLogs = async (data) => {
  // console.log(window.location.pathname);
  try {
    const response = await axiosHttp.post(
      `${API_CONSTANTS.CLIENT_PROGRESS_Dev_BASE_URL}server-progres`,
      {
        event_type: "get_model_output_logs",
        ...data,
      }
    );
    return response?.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const viewModelOutputImage = async (data) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.EDA_IMAGE}`, {
      event_type: "final_model_png",
      ...data,
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const upgradeServerVersion = async (data) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.EDA_IMAGE}`, {
      event_type: "upgrade_model",
      ...data,
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const downloadFinalModelCsv = async (data) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.EDA_IMAGE}`, {
      event_type: "final_model_csv",
      ...data,
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};

// export const getInfraList = async (infraData) => {
//   try {
//     const response = await axiosHttp.post(`${API_CONSTANTS.INFRA}`, {
//       action: "insert_record",
//       record: { ...infraData },
//     });
//     return response.data;
//   } catch (error) {
//     LOGGER(error);
//   }
// };
export const clientCreation = async (userData) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.PROJECT}`, {
      data: { ...userData },
      action: "client_info",
      log: activityLog.CLIENT_CREATE,
    });
    return response;
  } catch (error) {
    LOGGER(error);
  }
};
export const getProjectList = async () => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.PROJECT}?action=read_record&email=${userEmail}&userRole=${currentRole}`
    );
    const sortedProjects = [...response.data.body].sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
    );
    // projectType
    // console.log("============>", sortedProjects.filter((item)=>item.projectType == "FL"));
    const flProject = sortedProjects.filter((item) => item.projectType == "FL");
    return {
      ...response.data,
      body: flProject,
    };
  } catch (error) {
    LOGGER(error);
  }
};
export const getProjectCount = async () => {
  try {
    let urlForUsers = `${API_CONSTANTS.PROJECT}?action=project_count&email=${userEmail}`;
    let urlForPFA = `${API_CONSTANTS.PROJECT}?action=project_count`;
    let finalUrl;
    if (currentRole == "Platform_Admin") {
      finalUrl = urlForPFA;
    } else {
      finalUrl = urlForUsers;
    }
    const response = await axiosHttp.get(finalUrl);
    return response?.data?.body;
  } catch (error) {
    LOGGER(error);
  }
};
export const getProjectInfoById = async (proId) => {
  // console.log(window.location.pathname);
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.PROJECT}?action=read_record&record_id=${proId}`
    );
    return response.data?.body;
  } catch (error) {
    LOGGER(error);
  }
};

export const clientProgressDataWithStatus = async (pjk) => {
  try {
    const response = await axiosHttp.get(
      `${"https://lexhue53xg.execute-api.ap-southeast-1.amazonaws.com/prod/client-progress"}?event_type=client_progress&project_key=${pjk}`
    );
    if (response?.data?.statusCode == 200) {
      return response?.data?.body || [];
    } else {
      return [];
    }
  } catch (error) {
    LOGGER(error);
  }
};

export const notificationList = async () => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.BASE_URL}client?action=read_by_notification_list&notification_to=${userEmail}&user_role=${currentRole}`
    );
    if (response?.data?.statusCode === 200) {
      return (response?.data?.body || []).sort(
        (a, b) => new Date(b.created_time) - new Date(a.created_time)
      );
    } else {
      return [];
    }
  } catch (error) {
    LOGGER(error);
  }
};
export const resetNotification = async () => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.CLIENT}`, {
      action: "update_notify_status_value",
      notification_to: userEmail,
      read_status: "false",
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};

export const getClientInfoList = async () => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.CLIENT}?action=read_record`
    );
    const sortedProjects = [...response.data.body].sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
    );
    return sortedProjects;
  } catch (error) {
    LOGGER(error);
  }
};

export const updateProjectInfo = async (userData) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.PROJECT}`, {
      record: { record_id: userData.id, ...userData },
      action: "update_record",
      log: activityLog.PROJECT_INFO_UPDATED(userData),
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const deleteProject = async (id) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.PROJECT}`, {
      record: { record_id: id },
      action: "delete_record",
      log: activityLog.PROJECT_DELETED,
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};

export const createClient = async (clientData) => {
  try {
    const notificationTo = [];
    if (clientData?.clientManager) {
      notificationTo.push({ Client_Manager: clientData.clientManager });
    }

    if (clientData?.siteManager) {
      const uniqueSiteManagers = [
        ...new Set(clientData.siteManager.map((item) => item.email)),
      ];
      uniqueSiteManagers.forEach((email) => {
        notificationTo.push({ Site_Manager: email });
      });
    }
    const response = await axiosHttp.post(`${API_CONSTANTS.CLIENT}`, {
      action: "insert_record",
      record: { ...clientData },
      log: activityLog.CLIENT_REGION_CREATE(clientData),
      notificationLog: {
        title: "New Client Created",
        description: `New Client (${clientData?.clientName}) Added to the ${
          clientData.region
        } to those Sites: ${clientData?.siteManager?.map(
          (item) => item.siteName
        )} `,
        notificationType: "email",
        notificationTo,
        createdBy: { role: currentRole, email: userEmail },
      },
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const updateClient = async (clientData) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.CLIENT}`, {
      action: "update_record",
      record: { record_id: clientData?.record_id, ...clientData },
      log: activityLog.CLIENT_REGION_UPDATE(clientData),
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};

export const deleteClient = async (id) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.CLIENT}`, {
      record: { record_id: id },
      action: "delete_record",
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const backendEntryAssignClient = async (clientData) => {
  const id = getProjectId();
  if (id) {
    try {
      const response = await axiosHttp.post(`${API_CONSTANTS.PROJECT}`, {
        action: "update_records",
        record: clientData,
        projectId: id,
      });
      return response.data;
    } catch (error) {
      LOGGER(error);
    }
  } else {
    showError("Please complete the project info section!");
  }
};
export const assignClient = async (clientData) => {
  // console.log(clientData);
  const id = getProjectId();
  if (id) {
    try {
      const response = await axiosHttp.post(`${API_CONSTANTS.CLIENT_ASSIGN}`, {
        action: "insert_record",
        record: {
          clientId: clientData?.treeValue,
          projectId: id,
        },
        log: activityLog.CLIENT_ASSIGN(clientData?.filteredData),
      });
      return response.data;
    } catch (error) {
      LOGGER(error);
    }
  } else {
    showError("Please complete the project info section!");
  }
};
export const updateAssignClient = async ({
  treeValue,
  record_id,
  filteredData,
}) => {
  const id = getProjectId();
  if (id) {
    try {
      const response = await axiosHttp.post(`${API_CONSTANTS.CLIENT_ASSIGN}`, {
        action: "update_record",
        record: {
          clientId: treeValue,
          record_id: record_id,
        },
        log: activityLog.CLIENT_UPDATE_ASSIGN(filteredData),
      });
      return response.data;
    } catch (error) {
      LOGGER(error);
    }
  } else {
    showError("Please complete the project info section!");
  }
};
export const getAssignClientList = async () => {
  try {
    const response = await axiosHttp.get(
      `${
        API_CONSTANTS.CLIENT_ASSIGN
      }?action=read_record&projectId=${getProjectId()}`
    );
    return response.data?.body;
  } catch (error) {
    LOGGER(error);
  }
};
export const getProjectSpecificClientSiteListForUpload = async () => {
  try {
    const response = await axiosHttp.get(
      `${
        API_CONSTANTS.PROJECT
      }?action=filter_sites_by_project&projectId=${getProjectId()}&email=${userEmail}`
    );
    return response?.data?.body;
  } catch (error) {
    LOGGER(error);
  }
};
export const getClientsByProject = async () => {
  if (currentRole == "FL_Engineer") {
    try {
      const response = await axiosHttp.get(
        `${
          API_CONSTANTS.PROJECT
        }?action=filter_clients_by_project&projectId=${getProjectId()}&email=${userEmail}`
      );
      return response?.data?.body;
    } catch (error) {
      LOGGER(error);
    }
  } else {
    try {
      let clientsUserEmail = `&email=${userEmail}`;
      if (currentRole === "Project_Admin") {
        clientsUserEmail = "";
      }
      const response = await axiosHttp.get(
        `${
          API_CONSTANTS.PROJECT
        }?action=get_clients_by_project&projectId=${getProjectId()}&userRole=${currentRole}${clientsUserEmail}`
      );
      return response?.data?.body;
    } catch (error) {
      LOGGER(error);
    }
  }
};
export const getAssignedClientForInfraConfig = async () => {
  try {
    const response = await axiosHttp.get(
      `${
        API_CONSTANTS.PROJECT
      }?action=filter_clients_by_project&projectId=${getProjectId()}&email=${userEmail}`
    );
    return response?.data?.body;
  } catch (error) {
    LOGGER(error);
  }
};

export const getInfraList = async () => {
  try {
    const response = await axiosHttp.get(
      `${
        API_CONSTANTS.INFRA_LIST
      }?action=read_record&projectId=${getProjectId()}`
    );
    if (response?.data?.statusCode == 200) {
      return response?.data?.body;
    } else {
      return ["aws-integration"];
    }
  } catch (error) {
    LOGGER(error);
  }
};
export const getProjectLog = async () => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.LOG}?action=read_record&projectId=${getProjectId()}`
    );
    const sortedData = response.data?.body?.sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
    return sortedData;
  } catch (error) {
    LOGGER(error);
  }
};

export const createGithubConnection = async (gitInfo) => {
  const prjKey = gitInfo?.project_key;
  const { project_key, ...filteredGitInfo } = gitInfo; // Remove project_key

  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.MODEL}`, {
      action: "insert_record",
      record: {
        ...filteredGitInfo, // Use the filtered object
        projectId: getProjectId(),
        // "created_by":"",
        // "updated_by":""
      },
      gitNotifyLog: {
        title: "Github Configured",
        project_key_value: prjKey,
        description: null,
        notificationType: "email",
        notificationTo: null,
        region: "Singapore",
        createdBy: {
          role: currentRole,
          email: userEmail,
        },
      },
      log: activityLog.CREATE_GITHUB(gitInfo),
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const updateGithubConnection = async (gitInfo) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.MODEL}`, {
      action: "update_record",
      record: {
        ...gitInfo,
        projectId: getProjectId(),
      },
      log: activityLog.UPDATE_GITHUB(gitInfo),
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};

export const s3BucketCreateTrigger = async (s3BucketParam) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.JENKINS}`, {
      event_type: "aws_s3",
      name: s3BucketParam.clientName,
      region: s3BucketParam.region,
      // bucket_name: "",
      // region: userRegion,
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const generatePresignedUrl = async (preSignedPayload) => {
  try {
    const response = await axiosHttp.post(
      `${API_CONSTANTS.UPLOAD_BASE_URL}pre-signed-url`,
      preSignedPayload
    );
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};

// Dev/jenkins?
export const passJenkinsPayload = async (jenkinsPayload) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.JENKINS}/status`, {
      event_type: "job_status",
      job_name: jenkinsPayload.job_name,
      build_url: jenkinsPayload.build_url,
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const fetchGithubBranches = async (repoInfo) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.INFRA_LIST}`, {
      event_type: "get_repo",
      ...repoInfo,
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};

export const fetchGithubFilesList = async ({
  repoUrl,
  accessToken,
  branchName,
}) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.INFRA_LIST}`, {
      event_type: "get_files",
      repoUrl: repoUrl,
      accessToken: accessToken,
      branch: branchName,
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const pullLatestCommits = async (data) => {
  try {
    const response = await axiosHttp.post(`${API_CONSTANTS.JENKINS}/status`, {
      event_type: "git_pull",
      ...data,
      notificationLog: {
        title: "Pulled An New Commits from Github",
        project_key_value: data?.project_key,
        description: null,
        notificationType: "email",
        region: userRegion,
        notificationTo: null,
        createdBy: {
          role: currentRole,
          email: userEmail,
        },
      },
    });
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const getGithubConnectionFormData = async () => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.MODEL}?action=read_record&projectId=${getProjectId()}`
    );
    // Filter the data based on scriptType
    // const filteredData = response.data?.body?.filter(
    //   (item) => item.scriptType === modalType
    // );
    return response.data?.body || [];
  } catch (error) {
    LOGGER(error);
  }
};
export const fetchUserListByRegion = async (region, role) => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.USER_LIST}?event_type=region_wise_user_list&role=${role}&region=${region}`
    );
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const getProjectWiseUploadedList = async () => {
  try {
    const response = await axiosHttp.get(
      `${
        API_CONSTANTS.UPLOAD_BASE_URL
      }site?action=read_record&projectId=${getProjectId()}&email=${userEmail}&userRole=Site_Manager`
    );
    return response.data.body;
  } catch (error) {
    LOGGER(error);
  }
};
export const getProjectWiseUploadedListByEmail = async (email) => {
  try {
    const response = await axiosHttp.get(
      `${
        API_CONSTANTS.UPLOAD_BASE_URL
      }site?action=read_record&projectId=${getProjectId()}&email=${email}&userRole=Site_Manager`
    );
    return response.data.body;
  } catch (error) {
    LOGGER(error);
  }
};
export const getProjectWiseUploadedListAllBucketPath = async () => {
  try {
    const response = await axiosHttp.get(
      `${
        API_CONSTANTS.UPLOAD_BASE_URL
      }site?action=read_record&projectId=${getProjectId()}`
    );
    return response.data.body;
  } catch (error) {
    LOGGER(error);
  }
};
export const getIsRunEnableForCombineDataStatus = async (
  rowItems,
  filteredFiles,
  event
) => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.DATA_QC_STATUS}?bucketName=${filteredFiles[0]?.bucketName}&projectKey=${rowItems?.infra[0]?.project_key}&event_type=${event}`
    );
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const getTransformationDataQcAllStatus = async (
  rowItems,
  uploadedListData,
  event
) => {
  try {
    const bucketNames = uploadedListData.map((item) => item.bucketName);
    const uniqueBucketNames = [...new Set(bucketNames)];
    const response = await axiosHttp.get(
      `${API_CONSTANTS.DATA_QC_STATUS}?bucketName=${uniqueBucketNames}&projectKey=${rowItems?.infra[0]?.project_key}&event_type=${event}`
    );
    return response.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const InitialDataQCHeaderStatus = async (statusEvent) => {
  try {
    // First API call to get GitHub connection data

    const gitValues = await getGithubConnectionFormData();

    const { repoUrl, accessToken, branchName, dataQualityFolder } =
      gitValues[0];
    // Ensure gitValues are available before making the second API call
    if (repoUrl && accessToken && branchName) {
      // Second API call using values from the first API call
      const response = await axiosHttp.get(
        `${API_CONSTANTS.JENKINS}?event_type=file_search&repoUrl=${repoUrl}&accessToken=${accessToken}&branch=${branchName}&fileName=${statusEvent}`
      );
      return response?.data?.body;
    } else {
      LOGGER("GitHub connection data is incomplete.");
    }
  } catch (error) {
    LOGGER(error);
  }
};

export const scriptPresentHeaderStatus = async (statusEvent) => {
  try {
    const { event_type, repoUrl, accessToken, file_name, branch } = statusEvent;
    const response = await axiosHttp.get(
      `${API_CONSTANTS.JENKINS}?event_type=${event_type}&repoUrl=${repoUrl}&accessToken=${accessToken}&branch=${branch}&fileName=${file_name}`
    );
    return response?.data?.body;
  } catch (error) {
    LOGGER(error);
  }
};

export const runInitialDataQc = async (rowItems) => {
  // console.log("=========>", rowItems);
  try {
    // Validate infra and filteredSpecificSiteFile arrays
    if (!rowItems?.rowItems?.infra?.[0]?.name) {
      showError("Instance name not found!");
      return;
    }

    if (!rowItems?.filteredSpecificSiteFile?.[0]) {
      showError("Filtered specific site file not found!");
      return;
    }

    // Prepare the data for the API call
    const { name: instanceName, project_key: projectKey } =
      rowItems?.rowItems.infra[0];
    const { bucketName, bucketPath, fileName } =
      rowItems?.filteredSpecificSiteFile[0];

    // Make sure all required fields are available
    if (!bucketName || !bucketPath || !fileName) {
      showError("Missing bucket information or file name!");
      return;
    }
    let siteNames = [];
    let payloadForAPI;

    payloadForAPI = {
      event_type: rowItems?.eventType,
      instance_name: instanceName,
      bucketName: bucketName,
      bucketPath: bucketPath,
      projectKey: projectKey,
      fileName: fileName,
    };
    // Conditionally add siteName
    if (rowItems?.eventType === "combined_data_script_run") {
      payloadForAPI.siteName = rowItems?.siteName;
    }
    // Perform the API call
    const response = await axiosHttp.post(
      `${API_CONSTANTS.DATA_QC_STATUS}`,
      payloadForAPI
    );

    return response.data;
  } catch (error) {
    // Log the error for debugging
    LOGGER(error);
    showError("An error occurred while running the initial data QC.");
  }
};

export const clientShowEda = async (rowItems) => {
  try {
    console.log(rowItems);
    // Perform the API call
    const response = await axiosHttp.post(
      `${API_CONSTANTS.EDA_IMAGE}`,
      rowItems
    );

    return response.data;
  } catch (error) {
    // Log the error for debugging
    LOGGER(error);
    showError("An error occurred while running the initial data QC.");
  }
};
export const showModelCSV = async (rowItems) => {
  try {
    // console.log(rowItems);
    // Perform the API call
    const response = await axiosHttp.post(
      `${API_CONSTANTS.EDA_IMAGE}`,
      rowItems
    );

    return response.data;
  } catch (error) {
    // Log the error for debugging
    LOGGER(error);
  }
};
export const getLockedStatus = async (rowItems) => {
  try {
    const response = await axiosHttp.post(API_CONSTANTS.PRE_SIGNED_URL, {
      event_type: "locked_status",
      clients: rowItems?.clients,
      projectKey: rowItems?.projectKey,
    });
    return response?.data?.body;
  } catch (error) {
    LOGGER(error);
    throw error; // Ensure the error propagates if necessary
  }
};

export const getVersionList = async (rowItems) => {
  try {
    const response = await axiosHttp.post(API_CONSTANTS.PRE_SIGNED_URL, {
      event_type: "version_list",
      clients: rowItems?.clients,
      projectKey: rowItems?.projectKey,
    });
    return response?.data;
  } catch (error) {
    LOGGER(error);
    throw error; // Ensure the error propagates if needed
  }
};

export const versioningLockUnlock = async (rowItems) => {
  try {
    console.log(rowItems);
    // Perform the API call
    const response = await axiosHttp.post(`${API_CONSTANTS.PRE_SIGNED_URL}`, {
      ...rowItems,
      clientversionLog: {
        title: `File ${rowItems.event_type}`,
        project_key_value: rowItems?.projectKey,
        description: null,
        notificationType: "email",
        region: "",
        notificationTo: null,
        createdBy: {
          role: currentRole,
          email: userEmail,
        },
      },
    });
    if (response?.data?.statusCode === 200) {
      switch (rowItems?.event_type) {
        case "lock":
          showSuccess("Lock operation was successful!");
          break;
        case "unlock":
          showSuccess("Unlock operation was successful!");
          break;
        case "upgrade":
          showSuccess("Upgrade operation was successful!");
          break;
        default:
          console.log("Unknown operation performed!");
      }
    }
    return response.data;
  } catch (error) {
    // Log the error for debugging
    LOGGER(error);
  }
};
export const getScriptRunError = async (rowItems) => {
  try {
    // console.log(rowItems);
    // Perform the API call
    const response = await axiosHttp.post(
      `${API_CONSTANTS.CLIENT_PROGRESS_Dev_BASE_URL}client-progress`,
      rowItems
    );

    return response.data;
  } catch (error) {
    // Log the error for debugging
    LOGGER(error);
  }
};
export const downloadModel = async (rowItems) => {
  try {
    console.log(rowItems);
    // Perform the API call
    const response = await axiosHttp.post(
      `${API_CONSTANTS.EDA_IMAGE}`,
      rowItems
    );

    return response.data;
  } catch (error) {
    // Log the error for debugging
    LOGGER(error);
  }
};
export const runApproveReject = async (prjData) => {
  try {
    // console.log(prjData);
    const response = await axiosHttp.post(`${API_CONSTANTS.EDA_IMAGE}`, {
      ...prjData,
      log: activityLog.PROJECT_APPROVED(),
    });
    return response.data;
  } catch (error) {
    // Log the error for debugging
    LOGGER(error);
  }
};
export const serverVersionApprRej = async (prjData) => {
  try {
    // console.log(prjData);
    const response = await axiosHttp.post(
      `${API_CONSTANTS.CLIENT_PROGRESS_Dev_BASE_URL}server-progres`,
      {
        event_type: "approve/reject",
        ...prjData,
        notificationLog: {
          title: "Server Version Approved/Reject",
          project_key: prjData?.projectKey,
          description: `The Server version ${prjData?.server_version} has been ${prjData.status}`,
          notificationType: "email",
          region: "N.Virginia",
          notificationTo: null,
          createdBy: {
            role: currentRole,
            email: userEmail,
          },
        },
      }
    );
    return response.data;
  } catch (error) {
    // Log the error for debugging
    LOGGER(error);
  }
};
export const runFinalDataQc = async (rowItems) => {
  try {
    // Perform the API call
    const response = await axiosHttp.post(
      `${API_CONSTANTS.DATA_QC_STATUS}`,
      rowItems
    );

    return response.data;
  } catch (error) {
    // Log the error for debugging
    LOGGER(error);
    showError("An error occurred while running the initial data QC.");
  }
};
export const runFinalEDADataQc = async (rowItems) => {
  try {
    // Perform the API call
    const response = await axiosHttp.post(
      `${API_CONSTANTS.DATA_QC_STATUS}`,
      rowItems
    );

    return response.data;
  } catch (error) {
    // Log the error for debugging
    LOGGER(error);
    showError("An error occurred while running the initial data QC.");
  }
};

export const runModelTrain = async (trainData) => {
  try {
    // console.log(trainData);
    const response = await axiosHttp.post(`${API_CONSTANTS.MODEL_TRAIN}`, {
      ...trainData,
      log: activityLog.PROJECT_TRAIN_COMPLETED(),
    });
    return response.data;
  } catch (error) {
    // Log the error for debugging
    LOGGER(error);
    showError("An error occurred");
  }
};
export const getEachCellStatus = async (rowItems, filteredFiles, eventType) => {
  try {
    const response = await axiosHttp.get(
      `${API_CONSTANTS.DATA_QC_STATUS}?bucketName=${filteredFiles[0]?.bucketName}&bucketPath=${filteredFiles[0]?.bucketPath}&projectKey=${rowItems?.infra[0]?.project_key}&event_type=${eventType}`
    );
    return response?.data;
  } catch (error) {
    LOGGER(error);
  }
};
export const getAfterRunFinalStatus = async (
  rowItems,
  uploadedListData,
  eventType
) => {
  try {
    const payload = {
      bucketName: [...new Set(uploadedListData.map((item) => item.bucketName))],
      // bucketName: "federated-learning-platform",
      // bucketPath: [...new Set(uploadedListData.map((item) => item.bucketPath))],
    };

    const response = await axiosHttp.get(
      `${API_CONSTANTS.DATA_QC_STATUS}?bucketName=${payload?.bucketName}&projectKey=${rowItems?.infra[0]?.project_key}&event_type=${eventType}`
    );
    return response?.data;
  } catch (error) {
    LOGGER(error);
  }
};
// export const getInitialDataScriptStatus = async (rowItems) => {
//   try {
//     const response = await axiosHttp.get(
//       `${API_CONSTANTS.DATA_QC_STATUS}?bucketName=${rowItems?.fileList[0]?.bucketName}&bucketPath=${rowItems?.fileList[0]?.bucketPath}&projectKey=${rowItems?.infra[0]?.project_key}&event_type=initial_data_script_status`
//     );
//     return response.data.body;
//   } catch (error) {
//     LOGGER(error);
//   }
// };
